import { render, staticRenderFns } from "./UserRatedMovies.vue?vue&type=template&id=91b4ecfc&"
import script from "./UserRatedMovies.vue?vue&type=script&lang=js&"
export * from "./UserRatedMovies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports